type AppEnvironment = 'smsv3' | 'agni' | 'reddata' | 'ranksitt' | 'fahimit' | 'link3' | 'default'

interface EnvironmentConfiguration {
  appId: number
  baseUrl: string
  envClient: AppEnvironment
}

const ENVIRONMENT_CONFIG: Record<AppEnvironment, EnvironmentConfiguration> = {
  smsv3: {
    appId: 2, // this value can be changes 0 | 2 while developing
    baseUrl: 'https://apismsv3.iatlbd.com',
    envClient: 'smsv3',
    // envClient: 'ranksitt',
    // baseUrl: 'https://sms.reddata.com.bd',
    // envClient: 'reddata',
    // baseUrl: 'https://smscapi.link3.net',
    // envClient: 'link3',
  },
  agni: {
    appId: 2,
    baseUrl: 'https://smscapi.agni.com',
    envClient: 'agni',
  },
  reddata: {
    appId: 2,
    baseUrl: 'https://sms.reddata.com.bd',
    envClient: 'reddata',
  },
  ranksitt: {
    appId: 2,
    baseUrl: 'https://bsmsapi.ranksitt.net',
    envClient: 'ranksitt',
  },
  fahimit: {
    appId: 3,
    baseUrl: 'https://panel.bulksmsbd.org',
    envClient: 'fahimit',
  },
  link3: {
    appId: 2,
    baseUrl: 'https://smscapi.link3.net',
    envClient: 'link3',
  },
  default: {
    appId: 0,
    baseUrl: 'https://apismsv3.iatlbd.com',
    envClient: 'ranksitt',
  },
}

const HOSTNAME_TO_ENVIRONMENT: Record<string, AppEnvironment> = {
  // Localhost | development environment
  localhost: 'smsv3',
  'smsv3.iatlbd.com': 'smsv3',

  // Agni smsc environment
  'smsc.agni.com': 'agni',

  // Reddata smsc environemnt
  'sms.reddata.com.bd': 'reddata',

  // Ranksitt sms environment
  'bsms.ranksitt.net': 'ranksitt',

  // Link3 smsc environment
  'smsc.link3.net': 'link3',

  // Fahim route app environment
  'bulksmsbd.org': 'fahimit',
}

const getConfig = (): EnvironmentConfiguration => {
  const hostname = window.location.hostname
  const environemnt = HOSTNAME_TO_ENVIRONMENT[hostname]

  if (!environemnt) {
    console.warn(`[Config] Unknown hostname: ${hostname}, using default config`)
    return ENVIRONMENT_CONFIG['default']
  }

  return ENVIRONMENT_CONFIG[environemnt]
}

const config = getConfig()

export const app_id = config.appId
export const BASE_URL = config.baseUrl
export const ENV_CLIENT = config.envClient

// LOGO CONFIGURATION //
export const logoByHostname: Record<string, {favIcon: string; logo: string; iconLogo: string}> = {
  'smsc.agni.com': {
    favIcon: '/media/logos/agni/favicon.png',
    logo: '/media/logos/agni/agni-logo-login.png',
    iconLogo: '/media/logos/agni/agni-logo-sidebar.png',
  },
  'sms.reddata.com.bd': {
    favIcon: '/media/logos/reddata/reddata-favicon.ico',
    logo: '/media/logos/reddata/reddata-logo.png',
    iconLogo: '/media/logos/reddata/reddata-icon-logo.png',
  },
  'bsms.ranksitt.net': {
    favIcon: '/media/logos/favicon.ico',
    logo: '/media/logos/iatl-logo.png',
    iconLogo: '/media/logos/iatl-logo.png',
  },
  'smsv3.iatlbd.com': {
    favIcon: '/media/logos/favicon.ico',
    logo: '/media/logos/iatl-logo.png',
    iconLogo: '/media/logos/iatl-logo.png',
  },
  'smsc.link3.net': {
    favIcon: '/media/logos/link3/favicon.ico',
    logo: '/media/logos/link3/link3-logo.png',
    iconLogo: '/media/logos/link3/link3-logo.png',
  },
  localhost: {
    favIcon: '/media/logos/favicon.ico',
    logo: '/media/logos/iatl-logo.png',
    iconLogo: '/media/logos/iatl-logo.png',
  },
}

export const getLogoByHost = () => {
  const hostname = window.location.hostname
  return (
    logoByHostname[hostname] || {
      favIcon: '/media/logos/favicon.ico',
      logo: '/media/logos/iatl-logo.png',
      iconLogo: '/media/logos/iatl-logo.png',
    }
  )
}

export const allowedHostnames = Object.keys(logoByHostname)
